import type { BadgeWithTooltipType } from '@/core/components/badges/badge-type';
import type { KeyFactsType } from '@/features/key-facts-v2/key-facts-type';
import type { SeasonCalendarType } from '@/features/season-calendar/season-calendar-type';

import React from 'react';

import { Badges, KeyFactsDesktop } from '@/core/features';
import SeasonCalendar from '@/features/season-calendar/season-calendar';

interface SpotResultInfoContainerDesktopProps {
    badges: BadgeWithTooltipType[];
    calendar: SeasonCalendarType;
    keyFacts: KeyFactsType;
    onBadgeClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function SpotResultInfoContainerDesktop({
    badges,
    calendar,
    keyFacts,
    onBadgeClick,
}: SpotResultInfoContainerDesktopProps) {
    const hasBadges = badges.length > 0;
    return (
        <div className={'flex justify-between mb-8 text-14'}>
            <div className={'min-w-0'}>
                {hasBadges && (
                    <div
                        className={'flex flex-wrap items-center'}
                        // eslint-disable-next-line no-inline-styles/no-inline-styles
                        style={{ marginBottom: 13 }}
                    >
                        <Badges
                            badges={badges}
                            cursor={'cursor-default'}
                            onClick={onBadgeClick}
                            type={'horizontal'}
                            wrap={'wrap'}
                        />
                    </div>
                )}
                <div className={'flex flex-col gap-12'}>
                    <SeasonCalendar
                        rowCount={1}
                        seasonCalendar={calendar.seasonCalendar}
                        title={calendar.title}
                        titleMarginBottom={8}
                    />
                    <KeyFactsDesktop
                        fontSize={'text-12'}
                        gap={8}
                        keyFacts={keyFacts}
                        showIcon={false}
                        truncation={'oneLine'}
                    />
                </div>
            </div>
        </div>
    );
}
